module.exports = __webpack_public_path__ + "static/media/25.8b59b2a5.mp3";